import { render, staticRenderFns } from "./RiskCodeCreate.vue?vue&type=template&id=8ced5c54&scoped=true&"
import script from "./RiskCodeCreate.vue?vue&type=script&lang=js&"
export * from "./RiskCodeCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ced5c54",
  null
  
)

export default component.exports